// Messages for portal/Quotes (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.quotes.head': 'Quotes — Portal',
  'portal.quotes.title': 'Quotes',
  'portal.quotes.desc': 'Request and accept quotes — your agreed pricing',
  'portal.quotes.request_cta': 'Request a quote',
  'portal.quotes.tab.all': 'All',
  'portal.quotes.col.ref': 'Ref',
  'portal.quotes.col.lane': 'Lane',
  'portal.quotes.col.date': 'Quoted',
  'portal.quotes.col.transit': 'Transit',
  'portal.quotes.col.total': 'Total',
  'portal.quotes.empty': 'No quotes yet — request one above.',
  'portal.quotes.transit_days': '{days} days',
  'portal.quotes.accept': 'Accept',
  'portal.quotes.requests.title': 'Your requests',
  'portal.quotes.requests.state.requested': 'Requested',
  'portal.quotes.requests.state.in_progress': 'In progress',
  'portal.quotes.requests.state.quoted': 'Quoted',
  'portal.quotes.requests.state.closed': 'Closed',
  'portal.quotes.requests.requested_at': 'Requested {date}',
  'portal.quotes.notice':
    'Your pricing is confidential — these rates are visible only to your team.',
}

export const zhTW = {
  'portal.quotes.head': '報價 — 客戶入口',
  'portal.quotes.title': '報價',
  'portal.quotes.desc': '索取並接受報價 — 您的議定價格',
  'portal.quotes.request_cta': '索取報價',
  'portal.quotes.tab.all': '全部',
  'portal.quotes.col.ref': '編號',
  'portal.quotes.col.lane': '航線',
  'portal.quotes.col.date': '報價日期',
  'portal.quotes.col.transit': '運送時間',
  'portal.quotes.col.total': '總計',
  'portal.quotes.empty': '尚無報價 — 請於上方索取。',
  'portal.quotes.transit_days': '{days} 天',
  'portal.quotes.accept': '接受',
  'portal.quotes.requests.title': '您的申請',
  'portal.quotes.requests.state.requested': '已申請',
  'portal.quotes.requests.state.in_progress': '處理中',
  'portal.quotes.requests.state.quoted': '已報價',
  'portal.quotes.requests.state.closed': '已結案',
  'portal.quotes.requests.requested_at': '申請於 {date}',
  'portal.quotes.notice': '您的報價為機密資訊 — 這些價格僅限貴公司團隊查看。',
}
